// Sanitizza l'input di un campo importo (mln) pensato per mobile.
// Risolve il bug dello "0 incollato" dei campi type="number" su telefono:
// usare type="text" + inputMode="decimal" e passare il valore da qui.
// - accetta virgola o punto (normalizza a punto)
// - tiene solo cifre e un separatore decimale
// - rimuove gli zeri iniziali ("05" -> "5"), mantenendo "0." e "0"
export function sanitizeDecimalInput(raw) {
  let v = String(raw ?? "").replace(",", ".").replace(/[^0-9.]/g, "");
  const firstDot = v.indexOf(".");
  if (firstDot !== -1) {
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
  }
  v = v.replace(/^0+(?=\d)/, "");
  return v;
}
